import React, {useEffect} from "react";
import { useFormikContext } from "formik";
import Collapsible from "../../../../../components/collapsible";
import FancyRadioInput from "../../../../../components/form/fancy-radio-input";
import TextInput from "../../../../../components/form/text-input";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import PinBasedDebit from "../components/pin-based-debit";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";
import formBaseStyles from "../../../../../components/form/text-input/styles.module.scss";

const Surcharge = () => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext();

  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.grid}>
          <TextInput
            label={"Surcharge Rate"}
            placeholder={"0.00"}
            type={"text"}
            suffix={"%"}
            inputMode="decimal"
            id={"surcharge_rate"}
            name={"surcharge_rate"}
            value={values?.surcharge_rate}
            onBlur={handleBlur}
            touched={touched?.surcharge_rate}
            errored={errors?.surcharge_rate}
            error={errors?.surcharge_rate}
            hasWarning={getSoftLimitWarning(
              pricingDefaults?.surcharge?.surcharge_rate?.soft_limit,
              values.surcharge_rate,
              errors.surcharge_rate,
            )}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "surcharge_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />
          <TextInput
            label={"Per Txn"}
            placeholder={"0.00"}
            type={"text"}
            prefix={"$"}
            inputMode="decimal"
            id={"surcharge_per_transaction"}
            name={"surcharge_per_transaction"}
            value={values?.surcharge_per_transaction}
            onBlur={handleBlur}
            touched={touched?.surcharge_per_transaction}
            errored={errors?.surcharge_per_transaction}
            error={errors?.surcharge_per_transaction}
            hasWarning={getSoftLimitWarning(
              pricingDefaults?.surcharge?.surcharge_per_transaction?.soft_limit,
              values.surcharge_per_transaction,
              errors.surcharge_per_transaction,
            )}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "surcharge_per_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />
          <TextInput
            label={"Monthly Fee"}
            placeholder={"0.00"}
            type={"text"}
            prefix={"$"}
            inputMode="decimal"
            id={"surcharge_monthly_fee"}
            name={"surcharge_monthly_fee"}
            value={values?.surcharge_monthly_fee}
            onBlur={handleBlur}
            touched={touched?.surcharge_monthly_fee}
            errored={errors?.surcharge_monthly_fee}
            error={errors?.surcharge_monthly_fee}
            hasWarning={getSoftLimitWarning(
              pricingDefaults?.surcharge?.surcharge_monthly_fee?.soft_limit,
              values.surcharge_monthly_fee,
              errors.surcharge_monthly_fee,
            )}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "surcharge_monthly_fee",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />
        </div>
      </div>
      <div className={styles.debitStructureContainer}>
        <Collapsible title="Debit Fees" defaultExpanded>
          <label
            className={formBaseStyles.labelLarge}
            style={{ marginBottom: 0 }}
          >
            Select your preferred debit structure
          </label>
          <div className={styles.debitStructure}>
            <FancyRadioInput
              id="surcharge_ic_plus"
              name="tiered_amex_structure"
              label="IC+"
              value={"ic_plus"}
              checked={values.tiered_amex_structure == "ic_plus"}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
          </div>
         
          {values.tiered_amex_structure == "ic_plus" && (
            <div className={styles.debitStructureFieldsContainer}>
              <div className={styles.card}>
                <div className={styles.header}>
                  <h6>Signature Debit</h6>
                </div>

                <div className={`${styles.body}`}>
                  <TextInput
                    label={"IC+ Rate"}
                    placeholder={"0.00"}
                    suffix={"%"}
                    type="text"
                    inputMode="decimal"
                    id={"surcharge_signature_debit_rate"}
                    name={"surcharge_signature_debit_rate"}
                    value={values.surcharge_signature_debit_rate}
                    onBlur={handleBlur}
                    touched={touched?.surcharge_signature_debit_rate}
                    errored={errors?.surcharge_signature_debit_rate}
                    error={errors?.surcharge_signature_debit_rate}
                    hasWarning={getSoftLimitWarning(
                      pricingDefaults?.surcharge?.surcharge_signature_debit_rate
                        ?.soft_limit,
                      values.surcharge_signature_debit_rate,
                      errors.surcharge_signature_debit_rate,
                    )}
                    cleaveOptions={{
                      numeral: true,
                      numeralDecimalScale: 2,
                      numeralIntegerScale: 4,
                      numeralPositiveOnly: true,
                      onValueChanged: (e) => {
                        handleChange({
                          target: {
                            name: "surcharge_signature_debit_rate",
                            value: e.target.rawValue,
                          },
                        });
                      },
                    }}
                    disabled={nonEditableTemplateOrPricingRestricted}
                  />
                  <TextInput
                    label={"IC+ Txn"}
                    placeholder={"0.00"}
                    prefix={"$"}
                    inputMode="decimal"
                    id={"surcharge_signature_debit_per_transaction"}
                    name={"surcharge_signature_debit_per_transaction"}
                    value={values.surcharge_signature_debit_per_transaction}
                    onBlur={handleBlur}
                    touched={touched?.surcharge_signature_debit_per_transaction}
                    errored={errors?.surcharge_signature_debit_per_transaction}
                    error={errors?.surcharge_signature_debit_per_transaction}
                    hasWarning={getSoftLimitWarning(
                      pricingDefaults?.surcharge
                        ?.surcharge_signature_debit_per_transaction?.soft_limit,
                      values.surcharge_signature_debit_per_transaction,
                      errors.surcharge_signature_debit_per_transaction,
                    )}
                    cleaveOptions={{
                      numeral: true,
                      numeralDecimalScale: 2,
                      numeralIntegerScale: 4,
                      numeralPositiveOnly: true,
                      onValueChanged: (e) => {
                        handleChange({
                          target: {
                            name: "surcharge_signature_debit_per_transaction",
                            value: e.target.rawValue,
                          },
                        });
                      },
                    }}
                    disabled={nonEditableTemplateOrPricingRestricted}
                  />
                </div>
              </div>
            </div>
          )}
        </Collapsible>
      </div>

      <PinBasedDebit pricingModel="surcharge" />
    </>
  );
};

export default Surcharge;
